// extracted by mini-css-extract-plugin
module.exports = {"container":"AlEsUKk6NCYvMe+2KL4IlA==","head":"YJD7DNy2kjpbZiZd3R2Qng==","avatar":"lPxNm5oLvSFzJQPamy7xsg==","title":"R+U0xre2hvLOWs0ooNwm1A==","foot":"IqP0-BsAsssApPZDR66csQ=="};